<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="secondary">
            <dropdown
                :value="state"
                :options="filteredStates"
                native
                @input="onStateInput"
            />
        </template>

        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="themeObjectValues"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';
import { generateClass, getClassDefinition } from '@/utils/tailwind-helper';

export default {
    name: 'calendar-facet-day-font-weight',
    mixins: [baseOption],

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            displayName: 'Thickness',
            defaultIndex: 3,
            message: '* some options may not have any effect, depending on the currently loaded font family',
            tailwindDefinitionProp: 'fontWeight',
            state: '',
            states: [
                {
                    text: 'Default',
                    value: '',
                },
                {
                    text: 'Matching',
                    value: 'matching',
                    displayFor: ['a-link', 'nav-dropdown', 'advanced-nav-dropdown'],
                },
            ],
        };
    },

    computed: {
        filteredStates() {
            const { elementType } = this.selectedElements[0];

            return this.states.filter((state) => {
                if (state.displayFor) {
                    return state.displayFor.includes(elementType);
                }

                return true;
            });
        },
    },

    methods: {
        onInput(sizeIndex) {
            let cssClass = '';
            if (sizeIndex) {
                const size = this.themeObjectValues[sizeIndex];
                cssClass = generateClass({
                    screen: this.screen,
                    tailwindDefinitionProp: this.tailwindDefinitionProp,
                    value: size,
                });
            }

            this.onOptionChange(cssClass);
            this.$emit('input', cssClass);
        },

        onSelectedElement() {
            if (this.value) {
                const classDefinition = getClassDefinition(this.value);
                if (classDefinition) {
                    this.sliderIndex = this.themeObjectValues.findIndex(i => i === classDefinition.value);
                }
            }
        },
    },
};
</script>
